import React, { useEffect, useState } from 'react';
import "../../assets/Css/Style.css";
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

const OperationRecords = () => {
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState('');
  const [intervalFilter, setIntervalFilter] = useState('');
  const [dateRange, setDateRange] = useState({ from: '', to: '' });
  const [currentPage, setCurrentPage] = useState(1);
  const [allStocks, setAllStocks] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });

  const recordsPerPage = 20;
  // const ApiUrl = 'http://localhost:8090';
  const ApiUrl = 'https://stockbackend.idea2reality.tech';

  useEffect(() => {
    const fetchStockList = async () => {
      try {
        const response = await fetch(`${ApiUrl}/api/signals/operations`);
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        const data = await response.json();
        setAllStocks(data);
      } catch (err) {
        console.error('Stock fetch error:', err.message);
      }
    };
    fetchStockList();
  }, []);

  useEffect(() => {
    let filteredData = [...allStocks];

    if (search.trim()) {
      filteredData = filteredData.filter(r =>
        r.symbol?.toLowerCase().includes(search.toLowerCase()) ||
        r.operation_type?.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (intervalFilter) {
      filteredData = filteredData.filter(r => r.interval === intervalFilter);
    }

    if (dateRange.from && dateRange.to) {
      const from = new Date(dateRange.from);
      const to = new Date(dateRange.to);

      // Extend "to" to include the full day
      to.setHours(23, 59, 59, 999);

      filteredData = filteredData.filter(r => {
        const recDate = new Date(r.datetime);
        return recDate >= from && recDate <= to;
      });
    }


    if (sortConfig.key) {
      filteredData.sort((a, b) => {
        const aVal = a[sortConfig.key];
        const bVal = b[sortConfig.key];

        if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
        if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
      });
    }

    setFiltered(filteredData);
    setCurrentPage(1);
  }, [search, intervalFilter, dateRange, allStocks, sortConfig]);

  const requestSort = key => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const exportToCSV = () => {
    const worksheet = XLSX.utils.json_to_sheet(filtered);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Records');
    const excelBuffer = XLSX.write(workbook, { type: 'array', bookType: 'xlsx' });
    const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(data, 'operation_records.xlsx');
  };

  const indexOfLast = currentPage * recordsPerPage;
  const indexOfFirst = indexOfLast - recordsPerPage;
  const currentRecords = filtered.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filtered.length / recordsPerPage);

  const formatDateTime = (dateStr) => {
    console.log('dateStrdateStr', dateStr);
    const d = new Date(dateStr);
    const pad = (n) => n.toString().padStart(2, '0');

    const day = pad(d.getDate());
    const month = pad(d.getMonth() + 1);
    const year = d.getFullYear();
    const hours = pad(d.getHours());
    const minutes = pad(d.getMinutes());
    const seconds = pad(d.getSeconds());

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };

  const handleResetFilters = () => {
    setSearch('');
    setIntervalFilter('');
    setDateRange({ from: '', to: '' });
  };

  return (
    <div className="px-4 md:px-12 py-6 bg-gray-50 dark:bg-gray-900 min-h-screen text-gray-900 dark:text-gray-100">
      {/* Section Card: Export & Filters */}
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow p-6 mb-8">
        {/* Header + Export */}
        <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4 p-2">
          <h1 className="text-2xl md:text-3xl font-bold">📊 Operation Total Records - {allStocks.length}</h1>
          <h4 className="text-2xl md:text-3xl font-bold mx-2">Current Page Records - {currentRecords.length}</h4>

        </div>

        {/* Filter Bar */}
        <div className="flex flex-wrap md:flex-nowrap gap-4 mt-2 p-2">
          <button
            onClick={exportToCSV}
            className="bg-green-600 hover:bg-green-700 text-white font-medium px-4 py-2 rounded shadow mx-3"
          >
            📄 Export CSV
          </button>

          <button
            onClick={handleResetFilters}
            className="bg-gray-500 hover:bg-gray-600 font-medium px-4 py-2 rounded shadow me-3"
          >
            🔄 Reset Filters
          </button>
          <input
            type="text"
            placeholder="Search symbol/type"
            value={search}
            onChange={e => setSearch(e.target.value)}
            className="flex-1 min-w-[160px] p-2 rounded border dark:bg-gray-700 dark:border-gray-600"
          />
          <select
            value={intervalFilter}
            onChange={e => setIntervalFilter(e.target.value)}
            className="flex-1 min-w-[120px] p-2 rounded border dark:bg-gray-700 dark:border-gray-600 mx-3"
          >
            <option value="">All Intervals</option>
            <option value="1m">1m</option>
            <option value="5m">5m</option>
            <option value="15m">15m</option>
            <option value="1h">1h</option>
          </select>
          <input
            type="date"
            value={dateRange.from}
            onChange={e => setDateRange({ ...dateRange, from: e.target.value })}
            className="flex-1 min-w-[140px] p-2 rounded border dark:bg-gray-700 dark:border-gray-600"
          />
          <input
            type="date"
            value={dateRange.to}
            onChange={e => setDateRange({ ...dateRange, to: e.target.value })}
            className="flex-1 min-w-[140px] p-2 rounded border dark:bg-gray-700 dark:border-gray-600 mx-3"
          />
        </div>
      </div>

      {/* Section Card: Table View */}
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow p-4 overflow-x-auto mt-4">
        <table className="w-full min-w-[1000px] text-sm text-left border-collapse">
          <thead className="bg-blue-100 dark:bg-blue-900">
            <tr>
              {[
                'symbol',
                'operation_type',
                'interval',
                'last_high',
                'last_low',
                'first_datetime',
                'first_open',
                'first_high',
                'first_low',
                'first_close',
                'signal_datetime',
                'signal_high',
                'signal_low',
                'note',
              ].map(col => (
                <th
                  key={col}
                  onClick={() => requestSort(col)}
                  className={`px-4 py-2 cursor-pointer font-semibold ${col === 'symbol' ? 'w-auto whitespace-nowrap' : ''
                    }`}
                >
                  {col.replace('_', ' ').toUpperCase()}
                  {sortConfig.key === col && (sortConfig.direction === 'asc' ? ' 🔼' : ' 🔽')}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {currentRecords.length > 0 ? currentRecords.map(rec => (
              <tr
                key={rec._id}
                className={`border-b hover:bg-gray-50 dark:hover:bg-gray-800 ${['directionalBearish', 'piercingBearish', 'gapDown'].includes(rec.operation_type)
                  ? 'td-red-100'
                  : ['directionalBullish', 'piercingBullish', 'gapUp'].includes(rec.operation_type)
                    ? 'td-green-100'
                    : ''
                  }`}
              >
                <td className="px-1 py-2 ms-2 w-auto whitespace-nowrap">
                  <a
                    href={`https://in.tradingview.com/chart/?symbol=NSE%3A${rec.symbol.replace('.NS', '')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center text-blue-600 hover:underline"
                  >
                    <img
                      src="https://static.tradingview.com/static/images/favicon.ico"
                      alt="TV"
                      className="me-1"
                      style={{ height: '15px' }}
                    />
                    {rec.symbol.replace('.NS', '')}
                  </a>
                </td>

                <td className="px-4 py-2 text-cyan-700 dark:text-cyan-400">{rec.operation_type}</td>
                <td className="px-4 py-2">{rec.interval}</td>
                <td className="px-4 py-2 td-pink-100">{Number(rec.last_high).toFixed(2)}</td>
                <td className="px-4 py-2 td-pink-100">{Number(rec.last_low).toFixed(2)}</td>
                <td className="px-4 py-2 td-yellow-100">{formatDateTime(rec.datetime)}</td>
                <td className="px-4 py-2 td-yellow-100">{Number(rec.open).toFixed(2)}</td>
                <td className="px-4 py-2 td-yellow-100">{Number(rec.high).toFixed(2)}</td>
                <td className="px-4 py-2 td-yellow-100">{Number(rec.low).toFixed(2)}</td>
                <td className="px-4 py-2 td-yellow-100">{Number(rec.close).toFixed(2)}</td>
                <td className="px-4 py-2 td-blue-100">{rec.signal_timestamp ? formatDateTime(rec.signal_timestamp) : '-'}</td>
                <td className="px-4 py-2 td-blue-100">{Number(rec.signal_high).toFixed(2)}</td>
                <td className="px-4 py-2 td-blue-100">{Number(rec.signal_low).toFixed(2)}</td>
                <td className="px-4 py-2"><i>{rec.note || '-'}</i></td>
              </tr>
            )) : (
              <tr>
                <td colSpan="11" className="text-center px-4 py-4 text-gray-500 dark:text-gray-400">
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex justify-center items-center gap-2 mt-4">
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(p => p - 1)}
          className="px-3 py-1 rounded border dark:border-gray-700 bg-gray-200 dark:bg-gray-700 text-sm me-3"
        >
          ◀ Prev
        </button>
        <span className="text-sm">
          Page {currentPage} of {totalPages}
        </span>
        <button
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage(p => p + 1)}
          className="px-3 py-1 rounded border dark:border-gray-700 bg-gray-200 dark:bg-gray-700 text-sm ms-3"
        >
          Next ▶
        </button>
      </div>
    </div>
  );
};

export default OperationRecords;
